import UpdateMyAccountForm from "./UpdateMyAccountForm"

export default UpdateMyAccountForm
